import React, { useContext } from 'react';
import { makeStyles } from '@mui/styles';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { decodeJWT, getUserShortToken } from '../../../services/api';
import { Theme } from "../../../utils/themeContext";

import tokenLargeimg from "../../../assets/updated/xtokens logo.svg";
import bitcoinyay from '../../../assets/logo.webp'
import token from "../../../assets/homepage/updated/token.png";
import meme from "../../../assets/homepage/updated/meme.png";
import wisLogo from "../../../assets/homepage/updated/WIBS.svg";
import wisLogoLight from "../../../assets/updated/wibs with for light mode.svg";
import daCrazyWhiteMode from "../../../assets/tokenimages/daCrazyWhiteMode.svg";
import daCrazyBlackMode from "../../../assets/tokenimages/daCrazyBlackMode.svg";

const useStyles = makeStyles((theme: any) => ({
    root: {
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '20px',
        color: '#fff',
        fontFamily: 'Inter, sans-serif',
        marginTop: '120px'
    },
    headerLogoContainer: {
        width: '100%',
        maxWidth: '500px',
        marginBottom: '120px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    headerLogo: {
        width: '100%',
        height: 'auto',
    },
    tokenContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        gap: '60px',
        flexWrap: 'wrap',
        maxWidth: '1000px',
    },
    tokenItem: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        cursor: 'pointer',
        width: '160px',
        '&:hover $tokenIcon': {
            transform: 'scale(1.1)',
        },
    },
    iconWrapper: {
        width: '72px',
        height: '72px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: '20px',
    },
    tokenIcon: {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
        transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    },
    tokenName: {
        fontSize: '16px',
        fontWeight: 400,
        textAlign: 'center',
        color: '#E0E0E0',
        lineHeight: '1.4',
    },
    featureSection: {
        marginTop: '120px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    featureTitle: {
        fontSize: '26px',
        fontWeight: 500,
        marginBottom: '60px',
    },
    featureContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '80px',
        flexWrap: 'wrap',
        width: '100%',
        maxWidth: '1200px',
    },
    featureItem: {
        cursor: 'pointer',
        transition: 'transform 0.3s ease',
        '&:hover': {
            transform: 'scale(1.05)',
        },
    },
    wisLogo: {
        height: '90px',
        width: 'auto',
    },
    daCrazyLogo: {
        height: '160px',
        width: 'auto',
    }
}));

const IndexxTokenMain = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const themeData = useContext(Theme);

    const handleNavigation = async (url: string) => {
        const isAuthenticated = localStorage.getItem("access_token");
        const email = localStorage.getItem("email");

        let shortToken;
        if (email) {
            shortToken = await getUserShortToken(email);
        } else if (isAuthenticated) {
            let decodedValue: any = await decodeJWT(isAuthenticated);
            shortToken = await getUserShortToken(decodedValue?.email);
        }

        if (isAuthenticated && shortToken?.data) {
            const separator = url.includes('?') ? '&' : '?';
            const urlWithToken = `${url}${separator}signInToken=${shortToken.data}`;
            window.location.href = urlWithToken;
        } else {
            if (url.startsWith('http')) {
                window.location.href = url;
            } else {
                navigate(url);
            }
        }
    };

    return (
        <Box className={classes.root}>
            <Box className={classes.headerLogoContainer}>
                <Box
                    component="img"
                    src={tokenLargeimg}
                    className={classes.headerLogo}
                    alt="xTokens Logo"
                />
            </Box>

            <Box className={classes.tokenContainer}>
                {/* Indexx Crypto Token */}
                <Box className={classes.tokenItem} onClick={() => handleNavigation("/indexx-exchange/token-details")}>
                    <Box className={classes.iconWrapper}>
                        <Box component="img" src={token} className={classes.tokenIcon} style={{ width: "250px" }} alt="Indexx Crypto Token" />
                    </Box>
                    <Typography className={classes.tokenName}>Indexx Crypto Tokens</Typography>
                </Box>

                {/* Bitcoin Yay */}
                <Box className={classes.tokenItem} onClick={() => handleNavigation("https://bitcoinyay.com")}>
                    <Box className={classes.iconWrapper}>
                        <Box component="img" src={bitcoinyay} className={classes.tokenIcon} alt="Bitcoin Yay" />
                    </Box>
                    <Typography className={classes.tokenName}>Bitcoin Yay</Typography>
                </Box>

                {/* Memeniac */}
                <Box className={classes.tokenItem} onClick={() => handleNavigation("/meme-details")}>
                    <Box className={classes.iconWrapper}>
                        <Box component="img" src={meme} className={classes.tokenIcon} alt="Memeniac" />
                    </Box>
                    <Typography className={classes.tokenName}>Memeniac</Typography>
                </Box>
            </Box>

            {/* Feature of the Month Section */}
            <Box className={classes.featureSection}>
                <Typography
                    className={classes.featureTitle}
                    style={{ color: themeData?.theme === "dark" ? "white" : "black", fontSize: 24, marginBottom: 40 }}
                >
                    Feature of the Month
                </Typography>
                <Box className={classes.featureContainer}>
                    <Box
                        className={classes.featureItem}
                        onClick={() => handleNavigation("https://whoisbitcoinsatoshi.wtf")}
                    >
                        <Box
                            component="img"
                            src={themeData?.theme === "dark" ? wisLogo : wisLogoLight}
                            className={classes.wisLogo}
                            alt="Who Is Bitcoin Satoshi"
                        />
                    </Box>

                    <Box
                        className={classes.featureItem}
                        onClick={() => handleNavigation("https://dacrazyhawaiian.wtf/")}
                    >
                        <Box
                            component="img"
                            src={themeData?.theme === "dark" ? daCrazyBlackMode : daCrazyWhiteMode}
                            className={classes.daCrazyLogo}
                            alt="Da Crazy Hawaiian"
                        />
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default IndexxTokenMain;
